import React, { SyntheticEvent } from 'react';
import { AudioControlContext } from './AudioControl';

export default function AudioControlPlayButton() {
  const {
    isPlaying,
    doPause,
    doPlay,
  } = React.useContext(AudioControlContext);

  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const togglePlaying = () => {
    if (isPlaying) {
      doPause();
    } else {
      doPlay();
    }
  };

  const playButtonStyle = isPlaying ? { display: 'none' } : {};
  const pauseButtonStyle = isPlaying ? {} : { display: 'none' };
  return (
    <a href="/">
      <img src="/img/music/play_bt.svg" alt="再生" title="再生" className="disp_on" style={playButtonStyle} onClick={(e) => { cancelEvent(e); togglePlaying(); }} />
      <img src="/img/music/stop_bt.svg" alt="停止" title="停止" className="disp_on" style={pauseButtonStyle} onClick={(e) => { cancelEvent(e); togglePlaying(); }} />
    </a>
  );
}
